import { makeStyles } from '@material-ui/core/styles';

export const useDetectionStyles = makeStyles({
	tableContainer: {
		'& > .MuiGrid-container > .MuiPaper-elevation >.MuiTableContainer-root':
			{
				height: 'calc(100vh - 400px) !important',
				maxHeight: 'none !important',
				marginTop: '0',
			},
		// Applies margin to the last child div of the deeply nested Paper component in the table container
		'& > .MuiGrid-container > .MuiPaper-elevation > .MuiGrid-root > div:last-child':
			{
				marginRight: '70px',
			},
		// Applies padding and wrap to deeply nested filter chip items in the table container
		'& > .MuiGrid-container > .MuiGrid-item > .MuiGrid-item > .MuiGrid-item':
			{
				paddingLeft: '16px',
				flexWrap: 'wrap',
			},
	},
	tableContainerNoStatus: {
		'& > .MuiGrid-container > .MuiPaper-elevation >.MuiTableContainer-root':
			{
				height: 'calc(100vh - 290px) !important',
				maxHeight: 'none !important',
				marginTop: '0',
			},
		// Applies margin to the last child div of the deeply nested Paper component in the table container
		'& > .MuiGrid-container > .MuiPaper-elevation > .MuiGrid-root > div:last-child':
			{
				marginRight: '70px',
			},
		// Applies padding and wrap to deeply nested filter chip items in the table container
		'& > .MuiGrid-container > .MuiGrid-item > .MuiGrid-item > .MuiGrid-item':
			{
				paddingLeft: '16px',
				flexWrap: 'wrap',
			},
	},
});
